import { render, staticRenderFns } from "./ReglamentoConfirm.vue?vue&type=template&id=6e5ebf12"
import script from "./ReglamentoConfirm.vue?vue&type=script&lang=js"
export * from "./ReglamentoConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports